import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 px-4 bg-terracotta/10 relative overflow-hidden" data-id="element-114">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-white/40 blur-3xl -z-10 rounded-full" data-id="element-115" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white/80 backdrop-blur-sm p-8 md:p-12 rounded-[2.5rem] shadow-lg border border-white" data-id="element-117">
          <div className="flex justify-center gap-1 mb-8" data-id="element-118">
            {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-6 h-6 fill-gold text-gold" data-id="element-119" />)}
          </div>

          <QuoteIcon className="w-12 h-12 text-terracotta/30 mx-auto mb-6 rotate-180" data-id="element-120" />

          <p className="text-2xl md:text-3xl font-serif italic text-brown leading-relaxed mb-8" data-id="element-121">
            "En los primeros 3 días, la mayoría de las usuarias reporta que la
            'tensión' en la cintura del pantalón desaparece y que recuperan la
            energía que antes se perdía en digestiones pesadas. Es un cambio de
            volumen visible y una sensación de ligereza mental inmediata."
          </p>

          <div className="inline-flex items-center justify-center px-4 py-2 bg-sage/10 rounded-full text-sage font-medium text-sm uppercase tracking-wider" data-id="element-122">
            Resultados Reales
          </div>
        </motion.div>
      </div>
    </section>;
}